import { IFilter } from '../../types/filters';
import { ParkingContainer } from '../../containers/advancedFilters/ParkingContainer';

export const parking: IFilter = {
  component: ParkingContainer,
};
